angular.module('picmonicng').factory('XpService', [
  '$rootScope',
  '$timeout',
  'User',
  'toaster',
  'UserService',
  function ($rootScope, $timeout, User, toaster, UserService) {
    return {
      grant: function (source, sourceId, alertElement, style) {
        var self = this;

        var result = User.savev3({
          resource: 'xp',
          source: source,
          source_id: sourceId,
        });

        result.$promise.then(
          function (result) {
            if (alertElement) {
              self.showAlert(alertElement, result.amount, style);
            }

            if (result.achievements.length) {
              angular.forEach(result.achievements, function (achievement) {
                self.showAchievement(achievement);
              });
            }

            UserService.user.daily_streak = result.daily_streak;
            UserService.user.daily_streak_expiration = result.daily_streak.daily_streak_expiration;

            $rootScope.$broadcast('xp', {
              amount: result.amount,
            });
          },
          function () {
            // do nothing
          }
        );

        return result;
      },
      showAlert: function (targetElement, amount, style) {
        // Disable for LTI
        if ($rootScope.embed) {
          return;
        }

        var xpAlert = angular.element(
          '<div style="' + (style ? style : '') + '" class="karma-alert fade">' + amount + ' XP</div>'
        );
        angular.element(targetElement).append(xpAlert);
        $timeout(function () {
          xpAlert.remove();
        }, 1000);
      },
      showAchievement: function (achievement) {
        // Disable for LTI
        if ($rootScope.embed) {
          return;
        }

        toaster.pop({
          type: 'wait',
          bodyOutputType: 'directive',
          directiveData: { achievement: achievement },
          body: 'toaster-achievement',
          showCloseButton: true,
        });

        var sound;

        // Max Level
        if (achievement.levels.length - 1 === achievement.level) {
          sound = new Audio($rootScope.base_asset_url + '/assets/static/mp3/fairy-dust.mp3');
          // Default Sound
        } else {
          sound = new Audio($rootScope.base_asset_url + '/assets/static/mp3/achievement-three-tone-beep.mp3');
        }

        sound.oncanplay = function () {
          if (!UserService.user.quiz_mute) {
            sound.play();
          }
        };
      },
    };
  },
]);
